"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "popup-backdrop eh-popup-overlay" };
var _hoisted_2 = { class: "popup-content eh-popup-panel" };
var _hoisted_3 = { class: "action-buttons" };
var _hoisted_4 = {
    key: 0,
    class: "action-container"
};
var _hoisted_5 = { class: "action-text" };
var _hoisted_6 = { class: "action-signature" };
var _hoisted_7 = {
    key: 1,
    class: "close-row"
};
var vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'MedicationActionPopup',
    props: {
        timeObj: {
            type: Object,
            deafult: true
        },
        providerSignature: {
            type: String,
            required: true
        }
    },
    emits: ['close', 'action-selected'],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var actionmessage = (0, vue_3.ref)('');
        var buttonaction = (0, vue_3.ref)('');
        var finalnurseSig = (0, vue_3.ref)('');
        function resetActionItems() {
            buttonaction.value = "";
        }
        (0, vue_3.watch)(function () { return props.providerSignature; }, function (newValue) {
            // oldOrder will be undefined on first mount if you want extra safety,
            // but because we didn't set immediate: true this handler won't run on mount.
            //if (!oldnurseSig) return // optional guard
            console.log("Watch value");
            console.log(newValue);
            // Optional: only run when the id actually changed
            if (newValue === '')
                return;
            // Your logic when `order` updates
            handleSigUpdate(newValue);
        });
        function handleSigUpdate(newnurseSig) {
            finalnurseSig.value = newnurseSig; //props.providerSignature
            alert("it did run");
            console.log("watch value");
            console.log(finalnurseSig.value);
            console.log("Sig passed in from newnurseSig");
            console.log(newnurseSig);
        }
        function confirmAction() {
            //trigger confirmation alert
            var ask = confirm("Are you sure you want to confirm that the patient has " + buttonaction.value + " this medication?\n Once" +
                " confirmed this action will be final and then can no longer be modified.");
            if (ask == true) {
                //lets emit the action 
                var action = buttonaction.value;
                emit('action-selected', { action: action });
                emit('close');
            }
            else {
                //change the buttonaction value so I caln close the container
                buttonaction.value = ""; //should now close the container
            }
        }
        function showActionContainer() {
            if (buttonaction.value !== "") {
                return true;
            }
            else {
                return false;
            }
        }
        function chooseAction(action) {
            //update alert message 
            customAlertMessage(action);
            /*emit('action-selected', { action })
            emit('close')
            */
        }
        function customAlertMessage(action) {
            switch (action) {
                case "taken":
                    {
                        //lets clear actionmessage before setting it
                        actionmessage.value = "";
                        actionmessage.value = "Are you sure you want to apply " + action.toUpperCase() + " as the status for this medicaton?";
                        //set buttn action 
                        buttonaction.value = "taken";
                        //set provider signature 
                        finalnurseSig.value = props.providerSignature;
                        console.log("Signature values");
                        console.log(finalnurseSig.value);
                        console.log(props.providerSignature);
                        break;
                    }
                case "refused":
                    {
                        actionmessage.value = "";
                        actionmessage.value = "Are you sure you want to " + action.toUpperCase() + " as the status for this medication?";
                        //set button action
                        buttonaction.value = "refused";
                        //set provider signature
                        // nurseSig.value = props.providerSignature;
                        break;
                    }
            }
        }
        function emitClose() {
            emit('close');
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("h2", null, "Choose Action", -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "taken-btn",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (chooseAction('taken')); })
                        }, __spreadArray([], (_cache[3] || (_cache[3] = [
                            (0, vue_2.createElementVNode)("span", { class: "icon-check" }, "✔", -1),
                            (0, vue_2.createTextVNode)(" Taken ", -1)
                        ])), true)),
                        (0, vue_2.createElementVNode)("button", {
                            class: "later-btn",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (chooseAction('later')); })
                        }, __spreadArray([], (_cache[4] || (_cache[4] = [
                            (0, vue_2.createElementVNode)("span", { class: "icon-later" }, "⏳", -1),
                            (0, vue_2.createTextVNode)(" Take Later ", -1)
                        ])), true)),
                        (0, vue_2.createElementVNode)("button", {
                            class: "refused-btn",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (chooseAction('refused')); })
                        }, __spreadArray([], (_cache[5] || (_cache[5] = [
                            (0, vue_2.createElementVNode)("span", { class: "icon-x" }, "✘", -1),
                            (0, vue_2.createTextVNode)(" Refused ", -1)
                        ])), true))
                    ]),
                    (showActionContainer())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)(actionmessage.value), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("span", { class: "sig-label" }, "Signature:", -1)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(props.providerSignature), 1)
                            ]),
                            (0, vue_2.createElementVNode)("div", { class: "action-buttons" }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "confirm-yes",
                                    onClick: confirmAction
                                }, "Confirm Action"),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "confirm-no",
                                    onClick: resetActionItems
                                }, "Cancel Action")
                            ])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (!showActionContainer())
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("button", { onClick: emitClose }, "Close")
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ]));
        };
    }
});
